export const deviceTableDefaultColumns = [
  { id: 'name', label: 'Name', isVisible: true, disabled: true, root: true },
  { id: 'battery', label: 'Battery', isVisible: true, disabled: false },
  { id: 'temperature', label: 'Temperature', isVisible: true, disabled: false },
  { id: 'event', label: 'Event', isVisible: true, disabled: false },
  { id: 'details', label: 'Details', isVisible: true, disabled: false },
  { id: 'qrcode', label: 'QR', isVisible: true, disabled: false }
];
